import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Waterfall_light\"><path id=\"Rectangle\" d=\"M17.5 17.5H2.5\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path id=\"Vector\" d=\"M3.33331 13.3334V11.6667\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path id=\"Vector_2\" d=\"M10 10V7.5\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path id=\"Vector_3\" d=\"M6.66669 13.3333V8.33331\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path id=\"Vector_4\" d=\"M13.3333 10.8334V9.16669\" stroke=\"currentColor\" stroke-linecap=\"round\"></path><path id=\"Vector_5\" d=\"M16.6667 12.5V4.16669\" stroke=\"currentColor\" stroke-linecap=\"round\"></path></g>", 1)
  ])))
}
export default { render: render }